export function QuotationModalMilestones({ model }) {
  return <div>MILESTONES NOT IMPLEMENTED</div>;
}
